import React from "react";
import CheckedIcon from "./assets/checkedIcon.png";
import UncheckedIcon from "./assets/uncheckedIcon.png";
import "./iconCheckbox.css";

const IconCheckbox = ({
  label,
  checked,
  onChange,
  disabled,
  className = "",
  ...props
}) => {
  const handleClick = (e) => {
    if (disabled) return;
    if (onChange) {
      // Toggle the checked state
      onChange(!checked);
    }
  };

  return (
    <div
      className={`icon-checkbox ${className} ${disabled ? "disabled" : ""}`}
      onClick={handleClick}
      {...props}
    >
      <img
        src={checked ? CheckedIcon : UncheckedIcon}
        alt={checked ? "Checked" : "Unchecked"}
        className="icon-checkbox-icon"
      />
      <span className="icon-checkbox-label">{label}</span>
    </div>
  );
};

export default IconCheckbox;
